/**
 * Converte propriedades de um objeto em parametros de uma url
 * @param {*} sizeInBytes
 * @returns Url formatada
 */
 export const toUrlFormat = (params) => {
    let urlParams = '';
    Object.keys(params).forEach(
      (k) => (urlParams = `${urlParams}${k}=${params[k]}&`)
    );
    return `${urlParams}`;
  };